module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/207.6303a580.png";